import React from "react";

const CareersHero = () => {
  return (
    <section className="relative w-full h-[260px] sm:h-[340px] md:h-[420px] lg:h-[480px] overflow-hidden">
      {/* Background Image */}
      <img
        src="/assets/career/carrHero.png"
        alt="Careers at our company"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Dark cinematic overlay */}
      <div className="absolute inset-0 bg-black/10" />

      {/* Soft gradient for depth */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/35 to-transparent" />

      {/* Content */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <h1
          className="
            text-white
            font-bold
            text-2xl sm:text-3xl md:text-4xl lg:text-5xl
            tracking-wide
          "
        >
          Careers
        </h1>
      </div>
    </section>
  );
};

export default CareersHero;
